export const DEFAULT_TAG_SLUG = 'all-events';

export const useEventsStore = defineStore('events', {
  state: () => ({
    mainEvent: null,
    libraryEvents: [],
    upcomingEvents: [],
    eventDates: [],
    tags: [{ title: 'All events', slug: DEFAULT_TAG_SLUG }],
    tag: null,
    date: null,
    currentPage: 1,
    totalPages: 1,
    perPage: 5,
  }),
  actions: {
    setMainEvent(event) {
      this.mainEvent = event;
    },
    setLibraryEvents(events) {
      this.libraryEvents = [...this.libraryEvents, ...events.data];
      this.currentPage = Number(events.meta.pagination.current_page);
      this.totalPages = Number(events.meta.pagination.last_page);
    },
    setUpcomingEvents(events) {
      this.upcomingEvents = events;
    },
    resetEvents() {
      this.libraryEvents = [];
      this.upcomingEvents = [];
      this.currentPage = 1;
      this.totalPages = 1;
    },
    setEventDates(dates) {
      this.eventDates = dates;
    },
    setDate(date) {
      this.date = date;
    },
    setTags(tags) {
      this.tags = [{ title: 'All events', slug: DEFAULT_TAG_SLUG }, ...tags];
    },
    setTag(tag) {
      this.tag = tag;
    },
    incrementCurrentPage() {
      if (this.currentPage >= this.totalPages) {
        return;
      }
      this.currentPage += 1;
    },
  },
  getters: {
    tagSlugs: (state) => state.tags.map((tag) => tag.slug),
    filterParams(state) {
      const tag = this.tagSlugs.includes(state.tag) ? state.tag : null;

      return {
        ...(state.date && { date: state.date }),
        ...(tag && { tag }),
      };
    },
    paginationParams: (state) => ({
      page: state.currentPage,
      perPage: state.perPage,
    }),
    hasMoreEvents: (state) => state.currentPage < state.totalPages,
  },
});
